import React, { useEffect, useState } from "react";
import {saveAs} from 'file-saver';
import t from "../../service/translate.service";
import "./index.css";
import ContractSelector from "../../components/contractSelector";
import { inject, observer } from "mobx-react";
import { api } from "../../service/api.service";
import LoadingPageOverlay from "../../components/LoadingPageOverlay";
import { extractError } from "../../service/response.service";
import { Alert } from "antd";
import NoContent from "../../components/NoContent";
import { ContractsImage } from "../../components/icons";
import pdfSvg from "../../assets/svg/pdf.svg";
import icTmpPreview from "../../assets/ic-tmp-preview.png";
import icTmpDownload from "../../assets/ic-tmp-download.png";
import { Link } from "react-router-dom";
import find from 'lodash/find'

const Vouchers = (props) => {
  const [activeTab, setActiveTab] = useState("unhidden");
  const [loading, setLoading] = useState(false);
  const [firstLoading, setFirstLoading] = useState(true)
  const [vouchers, setVouchers] = useState([]);
  const [error, setError] = useState('');
  const urlParams = new URLSearchParams(window.location.search);
  const [contractNumber, setContractNumber] = useState('')
  const getVouchers = async (contractNumber, type) => {
    setLoading(true);
    await api
      .get(`/vouchers/${contractNumber}?type=${type}`)
      .then((res) => {
        setError('')
        setVouchers(res?.data || [])
      })
      .catch((error) => {
        setVouchers([])
        setError(t[extractError(error)] || t["ERROR"])
      });
    setLoading(false);
  };

  const getDocument = async (voucher) => {
    setLoading(true)
    const res = await api.get(`/vouchers/${props?.contractStore?.selectedContract?.contractNumber}/${voucher.Name}/file`, {
      responseType: 'blob',
    }).then((res) => {
      setError('')
      return res
    })
    .catch((error) => {
      setError(t[extractError(error)] || t["ERROR"])
    });
    setLoading(false)
    return res.data
  }

  const downloadDocument = async (voucher) => {
    try {
      setLoading(true)
      setError('')
      const file = await getDocument(voucher);
      saveAs(file, voucher.Name, {});
      await api.post(`/vouchers/${props?.contractStore?.selectedContract?.contractNumber}/${voucher?.UniqueId}/file`,
        {
          Downloaded: true
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      setError(t[extractError(error)] || t["ERROR"])
    }
  }

  const setDocumentHidden = async (voucher, hidden) => {
    setLoading(true)
    await api.post(`/vouchers/${props?.contractStore?.selectedContract?.contractNumber}/${voucher?.UniqueId}/file`,
      {
      Hidden: hidden
      })
    .then(async () => {
      if (activeTab && props?.contractStore?.selectedContract?.contractNumber) {
        await getVouchers(
          props?.contractStore?.selectedContract?.contractNumber,
          activeTab
        );
      }
    })
    .catch((error) => {
      setError(t[extractError(error)] || t["ERROR"])
    });
    setLoading(false)
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      if (activeTab && contractNumber) {
        await getVouchers(
          contractNumber,
          activeTab
        );
      }
    })();
  }, [activeTab, contractNumber]);

  useEffect(() => {
    if (firstLoading) {
      setFirstLoading(false)
      const contractFromParams = urlParams.get('contractNumber')
      if (contractFromParams) {
        const contract = find(props?.contractStore?.activeContracts, { contractNumber: contractFromParams })
        props.contractStore.selectedContract = contract
        setContractNumber(contractFromParams)
      } else {
        setContractNumber(props?.contractStore?.selectedContract?.contractNumber)
      }
    } else {
      setContractNumber(props?.contractStore?.selectedContract?.contractNumber)
    }
  }, [props?.contractStore?.selectedContract?.contractNumber]);

  if (loading) return <LoadingPageOverlay />;

  return (
    <div className="vouchers-page-wrap">
      {error && <Alert message={error} type='error' style={{marginTop: '12px', marginBottom: '12px'}} />}
      <div className="contract-selector-wrap">
        <ContractSelector page='vouchers' label padding contractNumber={contractNumber} />
      </div>
      <div className="tab-wrap">
        <button
          id="unhiddenBtn"
          type="button"
          onClick={() => setActiveTab("unhidden")}
          className={`tab-button ${activeTab == "unhidden" ? "active" : ""}`}
        >
          {t["VOUCHERS_UNHIDDEN"]}
        </button>
        <button
          id="hiddenBtn"
          type="button"
          className={`tab-button ${activeTab == "hidden" ? "active" : ""}`}
          onClick={() => setActiveTab("hidden")}
        >
          {t["VOUCHERS_HIDDEN"]}
        </button>
      </div>
      <div className="documents-list" style={{marginBottom: '30px', marginTop: '72px'}}>
        {vouchers?.length > 0 ? (
          vouchers?.map((voucher, i) => {
            return (
              <div key={i} className='item'>
                <div className='container'>
                  <div className='details'>
                    <div className='svg'>
                      <img src={pdfSvg} alt='PDF'/>
                    </div>
                    <div className='group'>
                      <div className='label'>{voucher.Name}</div>
                    </div>
                  </div>
                  <div className='actions'>
                    <Link
                      className='open-preview'
                      to={`/vouchers/${props?.contractStore?.selectedContract?.contractNumber}/${voucher?.Name}/preview`}
                    >
                      <img src={icTmpPreview} alt='Preview'/>
                    </Link>
                    <button
                      className='start-download'
                      onClick={(e) => {
                        downloadDocument(voucher)
                      }}
                    >
                      <img src={icTmpDownload} alt='Download'/>
                    </button>
                    <button
                      className='archive-restore'
                      onClick={(e) => {
                        setDocumentHidden(voucher, !voucher?.ListItemAllFields['Hidden'])
                      }}
                    >
                      {!voucher?.ListItemAllFields['Hidden'] ? t['VOUCHERS_HIDE'] : t['VOUCHERS_UNHIDE']}
                    </button>
                  </div>
                </div>
              </div>
            )
          })
        ) : (
          <div className="no-content-wrap">
            <NoContent message={t.NO_VOUCHERS} image={ContractsImage}/>
          </div>
        )}
      </div>
    </div>
  );
};

export default inject("contractStore")(observer(Vouchers));
